import React from "react";
import styles from "./about.module.css";
import {
  AcademicCapIcon,
  BookOpenIcon,
  SparklesIcon,
  ChartBarIcon,
  TrophyIcon,
} from "@heroicons/react/24/outline";

const About: React.FC = () => {
  return (
    <section
      id="about"
      className="py-16 bg-gradient-to-b from-blue-50 to-purple-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            About <span className="text-blue-600">Maraz Sir</span>
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl font-semibold text-teal-800">
            Dedicated to excellence in chemistry education for over the years
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="prose prose-lg max-w-none">
              <div className="space-y-4">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <AcademicCapIcon className="w-6 h-6 text-blue-600" />
                    <p className="font-medium text-lg">
                      10+ years of teaching experience
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <BookOpenIcon className="w-6 h-6 text-blue-600" />
                    <p className="font-medium text-lg">
                      Faculty of Scholastica
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <SparklesIcon className="w-6 h-6 text-blue-600" />
                    <p className="font-medium text-lg">
                      Expert in making complex concepts understandable
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <ChartBarIcon className="w-6 h-6 text-blue-600" />
                    <p className="font-medium text-lg">
                      Focus on building strong foundational knowledge
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <TrophyIcon className="w-6 h-6 text-blue-600" />
                    <p className="font-medium text-lg">
                      Proven track record of student success
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
                <div className="bg-blue-100 p-4 rounded-lg">
                  <div className="text-3xl font-bold text-blue-600">10+</div>
                  <div className="text-sm text-gray-600">Years Teaching</div>
                </div>
                <div className="bg-blue-100 p-4 rounded-lg">
                  <div className="text-3xl font-bold text-blue-600">500+</div>
                  <div className="text-sm text-gray-600">Students Taught</div>
                </div>
                <div className="bg-blue-100 p-4 rounded-lg">
                  <div className="text-3xl font-bold text-blue-600">100%</div>
                  <div className="text-sm text-gray-600">Success Rate</div>
                </div>
                <div className="bg-blue-100 p-4 rounded-lg">
                  <div className="text-3xl font-bold text-blue-600">70%</div>
                  <div className="text-sm text-gray-600">A*</div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 flex justify-center">
            <div className="w-full h-full overflow-hidden  flex items-center justify-center">
              {/* Placeholder for teacher's photo */}
              <img
                src="assets/images/marazsir1.jpg"
                alt="Chemistry Hero"
                className="w-[50%] h-[50%] object-cover rounded-full border-4 border-blue-500 mx-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
